import { render, staticRenderFns } from "./layout-basic.html?vue&type=template&id=4babdc04&scoped=true&"
import script from "./layout-basic.js?vue&type=script&lang=js&"
export * from "./layout-basic.js?vue&type=script&lang=js&"
import style0 from "./LayoutBasic.vue?vue&type=style&index=0&id=4babdc04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4babdc04",
  null
  
)

component.options.__file = "LayoutBasic.vue"
export default component.exports